import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import { ComputedRef } from '@vue/composition-api';

import Country from '@core/models/country/Country';
import countryStoreIndex from '@store/modules/data/country/countryIndex';

type CountriesList = {
    countries: ComputedRef<Country[]>;
    preselectedCountry: ComputedRef<Country | undefined>;
};

export function useCountriesList(shouldUseWhitelistedCountries = false): CountriesList {
    const countryStore = useVuexStore<typeof countryStoreIndex>('data/country');
    if (shouldUseWhitelistedCountries) {
        return {
            countries: countryStore.getter('whitelistedCountries'),
            preselectedCountry: countryStore.getter('preselectedWhitelistedCountry'),
        };
    } else {
        return {
            countries: countryStore.getter('countries'),
            preselectedCountry: countryStore.getter('preselectedCountry'),
        };
    }
}
